/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MovementStill { 
    DeviceId: string;
    Timestamp: string;
    SensorType: MovementStill.SensorTypeEnum;
    Event: MovementStill.EventEnum;
    Direction?: number | null;
    Speed?: number | null;
}
export namespace MovementStill {
    export const SensorTypeEnum = {
        G: 'G',
        T: 'T',
        P: 'P'
    } as const;
    export type SensorTypeEnum = typeof SensorTypeEnum[keyof typeof SensorTypeEnum];
    export const EventEnum = {
        NUMBER_1: 1
    } as const;
    export type EventEnum = typeof EventEnum[keyof typeof EventEnum];
}


